import React from 'react';

import ModalClose from 'components/ModalClose';

const ModalHeader = ({ title, fluid, transparent, alt, textCenter, onClose, children }) => {
    return (
        <div className={'modal-header' + (alt ? ' modal-header-alt' : '') + (fluid ? ' fluid' : '') + (transparent ? ' transparent' : '') + (onClose ? ' with-close' : '')}>
            {
                onClose ? <ModalClose onClick={onClose} /> : null
            }

            {
                children || <h1 className={textCenter ? 'text-center' : ''}>{ title }</h1>
            }
        </div>
    );
}

export default ModalHeader;
